import { render, staticRenderFns } from "./ListPropertiesInvestor.vue?vue&type=template&id=4b594eea&scoped=true&"
import script from "./ListPropertiesInvestor.vue?vue&type=script&lang=js&"
export * from "./ListPropertiesInvestor.vue?vue&type=script&lang=js&"
import style0 from "./ListPropertiesInvestor.vue?vue&type=style&index=0&id=4b594eea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b594eea",
  null
  
)

export default component.exports